import React from 'react';
import {
  Check,
} from 'lucide-react';

export const STEPS = [
  { id: 1, label: 'Type' },
  { id: 2, label: 'Search' },
  { id: 3, label: 'Select' },
  { id: 4, label: 'Purchase' },
  { id: 5, label: 'Done' },
];

/**
 * Progress breadcrumb for the purchase wizard.
 * @param {{ current: number }} props - Active step id (1–5).
 */
export default function StepBar({ current }) {
  return (
    <ol className="flex items-center gap-2 text-xs flex-wrap">
      {STEPS.map((s, i) => {
        const isActive = s.id === current;
        const isDone = s.id < current;
        const cls = isActive
          ? 'bg-civix-purple/30 text-white border-civix-purple/60'
          : isDone
            ? 'bg-emerald-500/15 text-emerald-300 border-emerald-500/40'
            : 'text-white/40 border-civix-border/50';
        return (
          <React.Fragment key={s.id}>
            <li
              aria-current={isActive ? 'step' : undefined}
              className={`px-3 py-1.5 rounded-md border flex items-center gap-2 ${cls}`}
            >
              <span className="w-5 h-5 rounded-full bg-black/30 inline-flex items-center justify-center text-[10px] font-mono">
                {isDone ? <Check className="w-3 h-3" /> : s.id}
              </span>
              {s.label}
            </li>
            {i < STEPS.length - 1 && <span className="text-white/20">›</span>}
          </React.Fragment>
        );
      })}
    </ol>
  );
}
